"use client";

import React, { useCallback, useEffect, useRef, useState } from "react";
import "./ServicesCarousel.css";

// Kept as an export so the same service details can power a dedicated services view.
export const serviceData = [
  {
    title: "Private Movie Screening",
    carouselTitle: "Private Screening",
    image: "/images/service-screening.jpeg",
    description:
      "Book our private theatres to enjoy your favorite movies and shows on a large HD screen with immersive surround sound and premium seating. Screen sizes and audio setups are designed to deliver a truly cinematic experience. For 3D theatre bookings, we provide 3D glasses to enhance the immersive viewing experience. Guests can stream content using their own OTT accounts, The HexaPlay's OTT subscriptions, or via laptops and pendrives. Our team supports all major OTT platforms and assists with setup to ensure a smooth and hassle-free movie experience.",
  },
  {
    title: "Decoration",
    carouselTitle: "Decoration",
    image: "/images/service-decoration.jpg",
    description:
      "The HexaPlay private theatres are designed to be the perfect celebration spaces for birthdays, anniversaries, proposals, romantic dates, and special milestones. Each theatre features a unique decor theme, and decoration is mandatory as part of the celebration package. Guests can also add extra decoration options during booking such as hanging photo walls, floral paths, candlelight setups, and themed arrangements. These personalized touches help create an intimate and unforgettable celebration experience with premium sound, visuals, and ambience.",
  },
  {
    title: "Snacks & Beverages",
    carouselTitle: "Food & Beverages",
    image: "/images/service-food.jpg",
    description:
      "A great celebration feels even better with delicious food. At The HexaPlay, we offer a variety of snacks and beverages to complement your private theatre experience. Our menu includes popular items such as French fries, momos, nuggets, soft drinks, and milkshakes. Outside food and beverages are not permitted inside the theatre. All snacks and drinks can be ordered from our in-house menu during your visit. Food and beverages are not included in the theatre booking and will be charged separately.",
  },
  {
    title: "Cakes",
    carouselTitle: "Cakes",
    image: "/images/service-cakes.jpg",
    description:
      "No celebration is complete without a cake. At The HexaPlay, we offer a range of delicious and budget-friendly cake options suitable for birthdays, anniversaries, proposals, and other special moments. Guests can easily add a cake during the booking process based on their preferred flavor and size. The cake will be arranged and ready at the theatre for your celebration. After the event, any remaining cake will be securely packed for takeaway so you can continue enjoying the celebration.",
  },
  {
    title: "Bouquets & Gifts",
    carouselTitle: "Gifts",
    image: "/images/service-gifts.jpg",
    description:
      "Make your celebration even more memorable with thoughtful gifting options at The HexaPlay. We offer a curated selection of bouquets, photo frames, soft toys, and decorative gift items that are perfect for surprising your loved ones.",
  },
  {
    title: "Fog Entry",
    carouselTitle: "Fog Entry",
    image: "/images/service-fog.jpg",
    description:
      "Fog Entry is our best-selling experience at The HexaPlay, designed to create a magical and cinematic entrance for every occasion. Step into a dreamy atmosphere where clouds of soft fog surround your path, adding a touch of elegance and mystery. Perfect for weddings, birthdays, and special celebrations, it transforms ordinary moments into unforgettable memories. The visual effect enhances photos and videos, making your grand entry truly picture-perfect. With professional setup and seamless execution, we ensure a smooth and stunning experience.",
    bestSeller: true,
  },
  {
    title: "Kids Celebration",
    carouselTitle: "Kids Celebration",
    image: "/images/service-kids.jpg",
    description:
      "Kids Celebration brings joy and excitement to every child's special day. We create fun-filled events designed to make lasting memories for kids. From colorful standees to engaging games, every detail is thoughtfully planned. Our creative cake-cutting setups add a magical touch to the celebration. Playful surprises keep children entertained and full of smiles. Each event is customized to match the theme and interests of the kids. We ensure a safe, vibrant, and joyful atmosphere for everyone.",
  },
  {
    title: "Bouquets",
    carouselTitle: "Bouquets",
    image: "/images/service-bouquets.jpg",
    description:
      "Beautiful fresh and artificial flower bouquet arrangements crafted to enhance every celebration. Designed with elegance to suit weddings, birthdays, and special occasions. Each bouquet brings a touch of freshness, charm, and vibrant beauty. Perfectly arranged to match your style and event theme. Customized arrangements make your moments truly unique and memorable.",
  },
  {
    title: "Photoshoot",
    image: "/images/photoshoot.jpg",
    description:
      "Capture every unforgettable moment of your special celebrations with our professional DSLR photoshoot service. Our expert photographers focus on delivering high-quality, stunning visuals that truly reflect your emotions. From candid smiles to grand highlights, we ensure every detail is beautifully preserved. Whether it is a birthday, wedding, or corporate event, we make your memories timeless.",
    bestSeller: true,
  },
  {
    title: "Canvas Painting",
    image: "/images/canva.jpg",
    description:
      "Canvas Painting transforms your most cherished memories into timeless works of art. Whether it is a special moment, a loved one, or a beautiful place, we bring your vision to life with creativity and precision. Our artists craft each piece with attention to detail and emotion, using high-quality materials for long-lasting, vibrant results.",
    bestSeller: true,
  },
  {
    title: "Customize Your Song",
    image: "/images/songg.jpg",
    description:
      "Customize your song and turn your special moments into unforgettable memories. Our personalized songs are crafted just for you with care and creativity. Whether it is a birthday, wedding, or any occasion, each song is designed to capture your feelings and bring them to life through music.",
    bestSeller: true,
  },
  {
    title: "VR Gaming",
    image: "/images/vr.jpg",
    description:
      "Step into a whole new world of immersive entertainment with VR gaming at The HexaPlay, where cutting-edge technology meets thrilling adventures. From action-packed battles to relaxing virtual explorations, there is something for everyone to enjoy. Whether you are visiting with friends or family, VR gaming at The HexaPlay creates unforgettable memories.",
    bestSeller: true,
  },
  {
    title: "PS5 Gaming",
    image: "/images/ps5.jpg",
    description:
      "Step into the world of high-end console gaming with our premium PS5 setup. Enjoy ultra-fast performance, stunning graphics, smooth gameplay, and next-generation features in a comfortable private setting.",
    bestSeller: true,
  },
  {
    title: "Karaoke",
    image: "/images/karaoke.jpg",
    description:
      "Turn your celebration into a lively and unforgettable musical experience. Enjoy singing your favorite songs with our premium karaoke setup and create fun moments with friends, family, and guests.",
    bestSeller: true,
  },
  {
    title: "Corporate Events",
    image: "/images/corporate.jpg",
    description:
      "Make your corporate events more engaging and memorable with innovative experiences. The HexaPlay brings solutions tailored for team outings and celebrations, encouraging collaboration and teamwork in a lively environment.",
    bestSeller: true,
  },
  {
    title: "VR Wedding Entertainment",
    image: "/images/wedding1.jpg",
    description:
      "VR Wedding Entertainment by The HexaPlay adds a modern and interactive twist to your wedding celebrations. Keep guests entertained with immersive virtual activities and transform a traditional celebration into a next-level digital experience.",
    bestSeller: true,
  },
];

const celebrationServices = [
  {
    title: "Birthday Celebration",
    tag: "Most loved",
    description:
      "Enjoy a pre-decorated private theatre that is ready the moment you arrive, and add cake, food, gifts and other experiences of your choice.",
    cta: "Plan a Birthday Celebration",
    target: "/birthday-celebration/",
    image: "/images/service-decoration.jpg",
    fallback:
      "https://images.pexels.com/photos/7600420/pexels-photo-7600420.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400",
  },
  {
    title: "Anniversary Celebration",
    tag: "For two",
    description:
      "Celebrate your journey together in a private theatre with an ambient, pre-set celebration setup, and add the details you prefer.",
    cta: "Plan an Anniversary Celebration",
    target: "/anniversary-celebration/",
    image: "/images/service-gifts.jpg",
    fallback:
      "https://images.pexels.com/photos/39219363/pexels-photo-39219363.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400",
  },
  {
    title: "Date Night",
    tag: "Just the two of you",
    description:
      "Spend uninterrupted time together in a comfortable private setting and personalize it with the add-ons you prefer.",
    cta: "Plan a Date Night",
    target: "/date-night/",
    image: "/images/service-screening.jpeg",
    fallback:
      "https://images.pexels.com/photos/39101729/pexels-photo-39101729.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400",
  },
  {
    title: "Proposals & Special Surprises",
    tag: "Big moments",
    description:
      "Make an important moment memorable in a ready-to-celebrate private theatre with add-ons such as fog entry, bouquets and gifts.",
    cta: "Plan Your Surprise",
    target: "/proposals-special-surprises/",
    image: "/images/service-fog.jpg",
    fallback:
      "https://images.pexels.com/photos/39219365/pexels-photo-39219365.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400",
  },
  {
    title: "Bride-to-Be Celebrations",
    tag: "With your people",
    description:
      "Celebrate the bride-to-be with close friends and family in a private theatre with food, entertainment and add-ons.",
    cta: "Plan a Bride-to-Be Celebration",
    target: "/bride-to-be-celebration/",
    image: "/images/service-bouquets.jpg",
    fallback:
      "https://images.pexels.com/photos/6822851/pexels-photo-6822851.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400",
  },
  {
    title: "Kids Celebration",
    tag: "Little legends",
    description:
      "Create a fun celebration for children with a pre-decorated private theatre, cakes and entertainment options.",
    cta: "Plan a Kids Celebration",
    target: "/kids-celebration/",
    image: "/images/service-kids.jpg",
    fallback:
      "https://images.pexels.com/photos/38786110/pexels-photo-38786110.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400",
  },
  {
    title: "Child's First Birthday",
    tag: "Milestone",
    description:
      "Make your little one's first birthday a milestone to remember in a pre-decorated private theatre.",
    cta: "Plan a First Birthday Celebration",
    target: "/first-birthday-celebration/",
    image: "/images/service-cakes.jpg",
    fallback:
      "https://images.pexels.com/photos/12689150/pexels-photo-12689150.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400",
  },
];

const addOns = [
  "Pre-decorated private theatre setup (included, fixed decor)",
  "Cakes",
  "Food & beverages",
  "Bouquets & gifts",
  "Fog entry",
  "Canvas painting",
  "Customized song",
  "Karaoke",
];

const DESKTOP_GAP = 24;
const DESKTOP_VISIBLE = 3;

const ArrowIcon = ({ direction = "right" }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    className={direction === "left" ? "svc-icon-left" : undefined}
  >
    <path
      d="M5 12h14M13 6l6 6-6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ImageWithFallback = ({ src, fallback, alt, className }) => {
  const handleError = (event) => {
    const image = event.currentTarget;
    if (!fallback || image.dataset.fallbackApplied) return;
    image.dataset.fallbackApplied = "true";
    image.src = fallback;
  };

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={handleError}
      loading="lazy"
      decoding="async"
    />
  );
};

const useIsMobile = () => {
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const query = window.matchMedia("(max-width: 768px)");
    setMobile(query.matches);
    const update = (event) => setMobile(event.matches);
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  return mobile;
};

const useCarousel = (length, visibleItems, interval) => {
  const maxIndex = Math.max(0, length - visibleItems);
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const lockRef = useRef(false);
  const releaseRef = useRef(null);
  const pauseRef = useRef(null);

  const change = useCallback(
    (getNext) => {
      if (lockRef.current) return;
      lockRef.current = true;
      setCurrent((previous) => {
        const nextValue = getNext(previous);
        return Math.min(Math.max(nextValue, 0), maxIndex);
      });
      window.clearTimeout(releaseRef.current);
      releaseRef.current = window.setTimeout(() => {
        lockRef.current = false;
      }, 680);
    },
    [maxIndex],
  );

  const next = useCallback(
    () => change((value) => (value >= maxIndex ? 0 : value + 1)),
    [change, maxIndex],
  );
  const prev = useCallback(
    () => change((value) => (value <= 0 ? maxIndex : value - 1)),
    [change, maxIndex],
  );
  const goTo = useCallback((index) => change(() => index), [change]);

  const pauseFor = useCallback((duration = 6000) => {
    setPaused(true);
    window.clearTimeout(pauseRef.current);
    pauseRef.current = window.setTimeout(() => setPaused(false), duration);
  }, []);

  useEffect(() => {
    if (paused || maxIndex === 0) return undefined;
    const timer = window.setInterval(next, interval);
    return () => window.clearInterval(timer);
  }, [interval, maxIndex, next, paused]);

  useEffect(
    () => () => {
      window.clearTimeout(releaseRef.current);
      window.clearTimeout(pauseRef.current);
    },
    [],
  );

  return {
    current,
    maxIndex,
    next,
    prev,
    goTo,
    paused,
    setPaused,
    pauseFor,
  };
};

const DesktopCarousel = () => {
  const { current, maxIndex, next, prev, goTo, setPaused } = useCarousel(
    celebrationServices.length,
    DESKTOP_VISIBLE,
    5200,
  );

  return (
    <div
      className="dsk-root"
      role="region"
      aria-roledescription="carousel"
      aria-label="HexaPlay celebrations"
    >
      <button
        className="dsk-arrow dsk-arrow-prev"
        onClick={prev}
        aria-label="Previous celebrations"
      >
        <ArrowIcon direction="left" />
      </button>

      <div
        className="dsk-viewport"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onFocus={() => setPaused(true)}
        onBlur={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget)) setPaused(false);
        }}
      >
        <div
          className="dsk-track"
          style={{
            transform: `translate3d(calc(-${current * (100 / DESKTOP_VISIBLE)}% - ${
              current * (DESKTOP_GAP / DESKTOP_VISIBLE)
            }px), 0, 0)`,
          }}
        >
          {celebrationServices.map((service, index) => (
            <a
              className="dsk-card"
              href={service.target}
              key={service.title}
              aria-label={service.cta}
            >
              <ImageWithFallback
                src={service.image}
                fallback={service.fallback}
                alt={service.title}
                className="dsk-card-img"
              />
              <span className="dsk-card-overlay" aria-hidden="true" />
              <span className="dsk-card-top">
                <span className="dsk-card-num">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="dsk-card-tag">{service.tag}</span>
              </span>
              <div className="dsk-card-body">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <span className="dsk-card-link">
                  {service.cta}
                  <ArrowIcon />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>

      <button
        className="dsk-arrow dsk-arrow-next"
        onClick={next}
        aria-label="Next celebrations"
      >
        <ArrowIcon />
      </button>

      <div className="dsk-dots" aria-label="Choose a carousel slide">
        {Array.from({ length: maxIndex + 1 }).map((_, index) => (
          <button
            key={index}
            className={`dsk-dot${index === current ? " dsk-dot-active" : ""}`}
            onClick={() => goTo(index)}
            aria-label={`Show slide ${index + 1}`}
            aria-current={index === current ? "true" : undefined}
          />
        ))}
      </div>
    </div>
  );
};

const MobileCarousel = () => {
  const { current, next, prev, goTo, pauseFor } = useCarousel(
    celebrationServices.length,
    1,
    4600,
  );
  const touchStart = useRef(0);
  const touchEnd = useRef(0);
  const suppressClick = useRef(false);

  const finishSwipe = () => {
    const distance = touchStart.current - touchEnd.current;
    if (Math.abs(distance) > 48) {
      suppressClick.current = true;
      distance > 0 ? next() : prev();
      window.setTimeout(() => {
        suppressClick.current = false;
      }, 400);
    }
    pauseFor();
  };

  return (
    <div
      className="mob-root"
      role="region"
      aria-roledescription="carousel"
      aria-label="HexaPlay celebrations"
    >
      <div className="mob-row">
        <button
          className="mob-arrow"
          onClick={() => {
            prev();
            pauseFor();
          }}
          aria-label="Previous celebration"
        >
          <ArrowIcon direction="left" />
        </button>

        <div
          className="mob-viewport"
          onTouchStart={(event) => {
            touchStart.current = event.targetTouches[0].clientX;
            touchEnd.current = event.targetTouches[0].clientX;
          }}
          onTouchMove={(event) => {
            touchEnd.current = event.targetTouches[0].clientX;
          }}
          onTouchEnd={finishSwipe}
        >
          <div
            className="mob-track"
            style={{ transform: `translate3d(-${current * 100}%, 0, 0)` }}
          >
            {celebrationServices.map((service, index) => (
              <a
                className="mob-card"
                href={service.target}
                key={service.title}
                onClick={(event) => {
                  if (suppressClick.current) event.preventDefault();
                }}
              >
                <div className="mob-img-wrap">
                  <ImageWithFallback
                    src={service.image}
                    fallback={service.fallback}
                    alt={service.title}
                  />
                  <span className="mob-img-gradient" aria-hidden="true" />
                  <span className="mob-badge">
                    {service.tag}
                  </span>
                  <span className="mob-counter">
                    {String(index + 1).padStart(2, "0")} /{" "}
                    {String(celebrationServices.length).padStart(2, "0")}
                  </span>
                </div>
                <div className="mob-footer">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <span className="mob-card-link">
                    {service.cta}
                    <ArrowIcon />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>

        <button
          className="mob-arrow"
          onClick={() => {
            next();
            pauseFor();
          }}
          aria-label="Next celebration"
        >
          <ArrowIcon />
        </button>
      </div>

      <div className="mob-dots" aria-label="Choose a celebration">
        {celebrationServices.map((service, index) => (
          <button
            key={service.title}
            className={`mob-dot${index === current ? " mob-dot-active" : ""}`}
            onClick={() => {
              goTo(index);
              pauseFor();
            }}
            aria-label={`Show ${service.title}`}
            aria-current={index === current ? "true" : undefined}
          />
        ))}
      </div>
    </div>
  );
};

const TextLink = ({ href, children }) => (
  <a className="svc-cta" href={href}>
    <span>{children}</span>
    <ArrowIcon />
  </a>
);

const ExperienceSection = ({
  eyebrow,
  title,
  description,
  cta,
  target,
  image,
  fallback,
  reverse = false,
}) => (
  <section
    className={`svc-experience${reverse ? " svc-experience-reverse" : ""}`}
    data-reveal
  >
    <div className="svc-experience-media">
      <ImageWithFallback src={image} fallback={fallback} alt={title} />
      <span className="svc-experience-media-ring" aria-hidden="true" />
    </div>
    <div className="svc-experience-copy">
      <p className="svc-kicker">{eyebrow}</p>
      <h2>{title}</h2>
      <p>{description}</p>
      <TextLink href={target}>{cta}</TextLink>
    </div>
  </section>
);

const ServicesCarousel = () => {
  const isMobile = useIsMobile();
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const items = root.querySelectorAll("[data-reveal]");
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      items.forEach((item) => item.classList.add("is-visible"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14 },
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <main className="svc-section" ref={rootRef}>
      <div className="svc-ambient svc-ambient-one" aria-hidden="true" />
      <div className="svc-ambient svc-ambient-two" aria-hidden="true" />
      <div className="svc-ambient svc-ambient-three" aria-hidden="true" />

      <header className="svc-header" data-reveal>
        <p className="svc-eyebrow">Celebration &amp; Private Theatre Services</p>
        <h1>
          Celebration &amp; Entertainment Services at <span>HexaPlay</span>
        </h1>
        <p className="svc-sub">
          At HexaPlay, you can choose from a range of celebration services and
          entertainment experiences designed for different occasions. From
          birthday celebrations and date nights to surprises, add-on experiences,
          private theatre screenings and gaming, everything is brought together in
          one place. Choose the experience you want and personalize it with the
          add-ons that make your occasion special.
        </p>
        <div className="svc-header-meta" aria-hidden="true">
          <span>Private theatre</span>
          <span>Pre-decorated setups</span>
          <span>Curated add-ons</span>
        </div>
      </header>

      <section className="svc-celebrations" data-reveal>
        <div className="svc-section-heading">
          <p className="svc-kicker">Make it yours</p>
          <h2>Celebrations</h2>
          <p>
            Every occasion is different, so your celebration should be designed
            around the moment you want to create. HexaPlay celebrations can be
            personalized for couples, families, children, friends and special
            occasions.
          </p>
        </div>
        {isMobile ? <MobileCarousel /> : <DesktopCarousel />}
      </section>

      <div className="svc-content">
        <section className="svc-addons" data-reveal>
          <div className="svc-addons-copy">
            <p className="svc-kicker">Personalize the moment</p>
            <h2>Add-On Experiences</h2>
            <p>
              Your private theatre is already pre-decorated. Make the celebration
              more personal by adding cakes, food and beverages, bouquets and
              gifts, fog entry, canvas painting, a customized song or karaoke, and
              combine them to suit your occasion.
            </p>
            <TextLink href="/add-on-experiences/">Explore All Add-Ons</TextLink>
          </div>
          <ul className="svc-addon-list" aria-label="Available add-on experiences">
            {addOns.map((addOn, index) => (
              <li key={addOn}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                {addOn}
              </li>
            ))}
          </ul>
        </section>

        <ExperienceSection
          eyebrow="Watch your way"
          title="Private Theatre Experience"
          description="Enjoy entertainment in a private and comfortable setting. Whether you are watching a movie with someone special, spending time with friends or adding a private screening to your celebration, the theatre gives you a more personal way to enjoy your time."
          cta="Explore Private Theatre"
          target="/private-theatre/"
          image="/images/service-screening.jpeg"
          fallback="https://images.pexels.com/photos/7991318/pexels-photo-7991318.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400"
        />

        <ExperienceSection
          eyebrow="Play together"
          title="Gaming"
          description="Looking for something more energetic? HexaPlay offers a dedicated gaming experience for friends, groups and gaming enthusiasts. Gaming can also be included in a group outing or special occasion."
          cta="Explore Gaming"
          target="/gaming/"
          image="/images/vr.jpg"
          fallback="https://images.pexels.com/photos/7562271/pexels-photo-7562271.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400"
          reverse
        />

        <ExperienceSection
          eyebrow="We bring the fun"
          title="Outdoor Event Entertainment"
          description="Planning a corporate, college, school or community event? HexaPlay can bring interactive gaming to your outdoor event."
          cta="Explore Outdoor Events"
          target="/EventServices"
          image="/images/corporate.jpg"
          fallback="https://images.pexels.com/photos/7561816/pexels-photo-7561816.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1400"
        />

        <section className="svc-finale" data-reveal>
          <p className="svc-kicker">One place, your occasion</p>
          <h2>Create Your Experience Your Way</h2>
          <p>
            You do not have to choose just one experience. Start with your
            celebration in a pre-decorated private theatre, add the services you
            need and personalize the experience around your occasion: a birthday
            with a cake, an anniversary with gifts, a kids' celebration with fun
            entertainment or a group outing with gaming.
          </p>
          <div className="svc-finale-actions">
            <TextLink href="/birthday-celebration/">
              Start with a Celebration
            </TextLink>
            <a className="svc-secondary-link" href="/add-on-experiences/">
              View add-ons
            </a>
          </div>
          <span className="svc-finale-wordmark" aria-hidden="true">
            HEXAPLAY
          </span>
        </section>
      </div>
    </main>
  );
};

export default ServicesCarousel;
